module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ../~/lodash/extend.js
// module id = 2621
// module chunks = 2